import * as React from "react"
import Button from "react-bootstrap/lib/Button"
import Avatar from "../avatar"
import { appStrings } from "../../common/strings/app_strings"

export class SettingsSection extends React.Component {
    constructor(props) {
        super(props)
    }

    renderAvatar = () => {
        const { hasAvatar, profile } = this.props
        return (
            !!hasAvatar && (
                <div className="avatar-container">
                    <Avatar
                        emailAddress={profile.email.address}
                        name={profile.name}
                    />
                </div>
            )
        )
    }

    render() {
        const {
            sectionTitle,
            saveAction,
            children,
            details,
            isDisabled,
        } = this.props
        return (
            <div className="section-wrapper">
                <div className="col-1">
                    <div className="settings-forms-container">
                        <h4>{sectionTitle}</h4>
                        {children}
                    </div>
                    {this.renderAvatar()}
                </div>
                <div className="col-2">
                    <Button
                        onClick={saveAction}
                        className="btn btn-primary"
                        disabled={isDisabled}
                    >
                        {appStrings.saveChanges}
                    </Button>
                    <div className="section-details">
                        <p>{details}</p>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/settings/settings_section.jsx